import { useState } from "react";
import { X, Copy, Check, Share2 } from "lucide-react";
import { toast } from "sonner";

// SVG glyphs for each platform — kept inline to avoid extra deps.
const XLogo = (p) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...p}>
        <path d="M18.244 2H21.5l-7.5 8.575L23 22h-6.875l-5.39-7.04L4.5 22H1.244l8.075-9.226L1 2h7.063l4.873 6.444L18.244 2Zm-1.205 18h1.91L7.05 4H5.012l12.027 16Z" />
    </svg>
);
const TelegramLogo = (p) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...p}>
        <path d="M21.94 4.45c.21-1.05-.79-1.94-1.78-1.57L2.6 9.85c-1.16.47-1.13 2.16.05 2.57l3.78 1.32 2.21 6.96c.27.85 1.35 1.13 1.99.52l2.81-2.66 4.07 2.95c.71.51 1.72.13 1.91-.72l3.52-15.84ZM7.66 14.06l8.04-5.02-6.05 5.65-.24 2.74-1.75-3.37Z" />
    </svg>
);
const WhatsAppLogo = (p) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...p}>
        <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.46 1.32 4.97L2 22l5.25-1.38a9.86 9.86 0 0 0 4.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91C21.96 6.45 17.5 2 12.04 2Zm0 18.1h-.01a8.2 8.2 0 0 1-4.17-1.14l-.3-.18-3.12.82.83-3.05-.2-.31a8.16 8.16 0 0 1-1.25-4.33c0-4.52 3.68-8.2 8.21-8.2 2.19 0 4.25.86 5.8 2.4a8.15 8.15 0 0 1 2.4 5.8c0 4.53-3.68 8.2-8.2 8.2Zm4.5-6.13c-.25-.12-1.46-.72-1.68-.8-.22-.08-.39-.12-.55.12-.16.25-.62.8-.76.96-.14.17-.28.18-.52.06-.25-.12-1.04-.38-1.98-1.22-.73-.65-1.22-1.45-1.37-1.7-.14-.25-.02-.39.11-.5.12-.11.25-.28.37-.42.12-.14.16-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.55-1.33-.76-1.83-.2-.48-.4-.41-.55-.42-.14-.01-.31-.01-.47-.01-.17 0-.43.06-.66.31-.22.25-.86.85-.86 2.08 0 1.23.89 2.41 1.01 2.58.12.17 1.75 2.67 4.24 3.74.59.26 1.06.41 1.42.53.6.19 1.14.16 1.57.1.48-.07 1.46-.6 1.67-1.18.21-.58.21-1.07.14-1.18-.06-.1-.22-.16-.46-.28Z" />
    </svg>
);
const RedditLogo = (p) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...p}>
        <path d="M22 12.14a2.14 2.14 0 0 0-3.62-1.55c-1.43-1-3.36-1.65-5.5-1.74l1.05-3.32 2.83.67a1.71 1.71 0 1 0 .19-1.5l-3.39-.8a.75.75 0 0 0-.9.51l-1.27 4.02c-2.27.06-4.32.73-5.8 1.77a2.14 2.14 0 1 0-2.55 3.39 4.18 4.18 0 0 0-.05.65c0 3.31 4 6 8.93 6s8.93-2.69 8.93-6c0-.21-.02-.42-.05-.62A2.13 2.13 0 0 0 22 12.14Zm-14.5 1.45a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm9 4.07c-1.02.87-2.7 1.34-4.5 1.34s-3.48-.47-4.5-1.34a.5.5 0 1 1 .67-.74c.8.7 2.27 1.08 3.83 1.08s3.03-.38 3.83-1.08a.5.5 0 1 1 .67.74ZM15 15.09a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z" />
    </svg>
);
const LinkedInLogo = (p) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...p}>
        <path d="M20.45 20.45h-3.55v-5.57c0-1.33-.03-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.95v5.66H9.36V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.38-1.85 3.61 0 4.27 2.38 4.27 5.47v6.27ZM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12ZM7.12 20.45H3.56V9h3.56v11.45ZM22.22 0H1.78C.8 0 0 .78 0 1.74v20.51C0 23.21.8 24 1.78 24h20.45c.97 0 1.77-.79 1.77-1.75V1.74C24 .78 23.2 0 22.22 0Z" />
    </svg>
);
const FacebookLogo = (p) => (
    <svg viewBox="0 0 24 24" fill="currentColor" {...p}>
        <path d="M22 12.07A10 10 0 1 0 10.13 22v-7.03H7.55v-2.9h2.58V9.84c0-2.55 1.51-3.96 3.83-3.96 1.11 0 2.27.2 2.27.2v2.5h-1.28c-1.26 0-1.65.78-1.65 1.59v1.9h2.8l-.45 2.9h-2.35V22A10 10 0 0 0 22 12.07Z" />
    </svg>
);

const PLATFORMS = [
    {
        key: "x", label: "X / Twitter", color: "hover:bg-zinc-900",
        Icon: XLogo,
        href: (url, text) => `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`,
    },
    {
        key: "telegram", label: "Telegram", color: "hover:bg-sky-500/10",
        Icon: TelegramLogo,
        href: (url, text) => `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`,
    },
    {
        key: "whatsapp", label: "WhatsApp", color: "hover:bg-emerald-500/10",
        Icon: WhatsAppLogo,
        href: (url, text) => `https://wa.me/?text=${encodeURIComponent(text + " " + url)}`,
    },
    {
        key: "reddit", label: "Reddit", color: "hover:bg-orange-500/10",
        Icon: RedditLogo,
        href: (url, text) => `https://www.reddit.com/submit?url=${encodeURIComponent(url)}&title=${encodeURIComponent(text)}`,
    },
    {
        key: "linkedin", label: "LinkedIn", color: "hover:bg-blue-500/10",
        Icon: LinkedInLogo,
        href: (url) => `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
    },
    {
        key: "facebook", label: "Facebook", color: "hover:bg-blue-600/10",
        Icon: FacebookLogo,
        href: (url) => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
    },
];

/**
 * Cross-platform share modal.
 * - Native Web Share API (mobile) → routes to any installed app: WhatsApp,
 *   Instagram DM, Messages, Discord, Signal, IG Stories, etc.
 * - 6 desktop deep-links: X, Telegram, WhatsApp, Reddit, LinkedIn, Facebook.
 * - Copy-link fallback for everything else (Discord, Slack, email, etc.).
 */
export default function ShareModal({ title, text, url, onClose }) {
    const [copied, setCopied] = useState(false);
    const shareText = text || title || "";

    const canNativeShare = typeof navigator !== "undefined" && typeof navigator.share === "function";

    const onNativeShare = async () => {
        try {
            await navigator.share({ title, text: shareText, url });
        } catch {
            // user cancelled or unsupported — silently ignore
        }
    };

    const onCopy = async () => {
        try {
            await navigator.clipboard.writeText(url);
            setCopied(true);
            toast.success("Proof link copied to clipboard");
            setTimeout(() => setCopied(false), 2000);
        } catch {
            toast.error("Copy failed — long-press the link below to copy manually");
        }
    };

    return (
        <div
            className="fixed inset-0 bg-black/75 backdrop-blur-sm z-[60] grid place-items-center px-4"
            data-testid="share-modal"
            onClick={onClose}
        >
            <div
                className="w-full max-w-md bg-[#0A0A0C] border border-[#1F1F24] rounded-sm"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="px-5 py-4 border-b border-[#1F1F24] flex items-start justify-between gap-3">
                    <div>
                        <div className="text-[10px] font-mono uppercase tracking-[0.22em] text-cyan-400">Share this trade</div>
                        <div className="text-base font-medium mt-1">Verified on-chain — share anywhere</div>
                    </div>
                    <button
                        data-testid="share-modal-close"
                        onClick={onClose}
                        className="text-zinc-500 hover:text-zinc-200 p-1"
                    >
                        <X className="w-4 h-4" />
                    </button>
                </div>

                <div className="p-5 grid gap-4">
                    {canNativeShare && (
                        <button
                            data-testid="share-native"
                            onClick={onNativeShare}
                            className="w-full flex items-center justify-center gap-2 py-2.5 bg-cyan-400 hover:bg-cyan-300 text-black text-xs uppercase tracking-widest font-semibold rounded-sm"
                        >
                            <Share2 className="w-3.5 h-3.5" />
                            Share via device · Instagram, Messages, Discord…
                        </button>
                    )}

                    <div className="grid grid-cols-3 gap-2">
                        {PLATFORMS.map(({ key, label, color, Icon, href }) => (
                            <a
                                key={key}
                                data-testid={`share-${key}`}
                                href={href(url, shareText)}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={`flex flex-col items-center justify-center gap-1.5 py-3 border border-[#1F1F24] rounded-sm text-zinc-300 hover:border-zinc-600 transition-colors ${color}`}
                            >
                                <Icon className="w-5 h-5" />
                                <span className="text-[9.5px] font-mono uppercase tracking-[0.16em]">{label}</span>
                            </a>
                        ))}
                    </div>

                    <div className="grid gap-1.5">
                        <div className="text-[9px] font-mono uppercase tracking-[0.22em] text-zinc-500">Proof link</div>
                        <div className="flex items-stretch gap-2">
                            <input
                                data-testid="share-url-input"
                                readOnly
                                value={url}
                                onClick={(e) => e.target.select()}
                                className="flex-1 bg-[#050505] border border-[#1F1F24] px-3 py-2 font-mono text-[11px] text-zinc-300 rounded-sm outline-none focus:border-cyan-500/50 truncate"
                            />
                            <button
                                data-testid="share-copy"
                                onClick={onCopy}
                                className="inline-flex items-center gap-1.5 px-3 py-2 border border-cyan-500/40 hover:border-cyan-400 text-cyan-400 hover:text-cyan-300 text-[10px] font-mono uppercase tracking-widest rounded-sm"
                            >
                                {copied ? <Check className="w-3 h-3" /> : <Copy className="w-3 h-3" />}
                                {copied ? "Copied" : "Copy"}
                            </button>
                        </div>
                        <div className="text-[9.5px] font-mono text-zinc-600">
                            Public, read-only. Shows the swap stats + every Hyperliquid testnet tx.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
